import api from './api';

export async function login(email, password) {
    const res = await api.post('/auth/login', { email, password });
    if (res.data.token) localStorage.setItem('ag_token', res.data.token);
    return res.data;
}

export async function register(email, password, profile) {
    const res = await api.post('/auth/register', { email, password, ...profile });
    return res.data;
}

export async function resendVerification(email) {
    const res = await api.post('/auth/resend-verification', { email });
    return res.data;
}

export async function getProfile() {
    const res = await api.get('/auth/profile');
    return res.data;
}

export async function updateProfile(data) {
    const res = await api.put('/auth/profile', data);
    return res.data;
}

export async function deactivateAccount() {
    const res = await api.delete('/auth/account');
    return res.data;
}

export async function completeGoogleRegistration(token, data) {
    const res = await api.put('/auth/complete-google', data, {
        headers: { Authorization: `Bearer ${token}` }
    });
    return res.data;
}

export function googleAuthUrl() {
    return `${api.defaults.baseURL.replace(/\/api\/?$/, '')}/api/auth/google`;
}

export function logout() {
    localStorage.removeItem('ag_token');
}

export function isAuthenticated() {
    return !!localStorage.getItem('ag_token');
}
